/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import MainHeader from "../../../../Shared/components/Header";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { Row, Col, Image, Space } from "antd";
import { NavLink } from "react-router-dom";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Button, TextField, Box, Typography } from "@mui/material";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { ListTable } from './ListTable';
import actions from "../../redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import crudActions from "../../../../CRUD/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";


const WorkFlow = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');   
    const { workflowDetails, workflowLoader } = useSelector(state => state.younoteAdminSetupReducer);
    const { editDetails, editError, editLoader, createDetails, createError, createLoader } = useSelector(state => state.crudReducer);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const { history } = props;
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [addMore, setAddMore] = useState(false);
    const [view, setView] = useState(false);
    const [error, setError] = useState({});
    const [form, setForm] = useState({});
    const [visible, setVisible] = useState(false);
    const [workflowId, setWorkflowId] = useState('');
    const [importVisible, setImportVisible] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [name, setName] = useState('');
    const dispatch = useDispatch();

    const handleAddMore = (e) => {
        createWorkflow(e);
        setAddMore(true);
    }

    const handleOpen = () => {
        setWorkflowId('');
        setVisible(true);
        emptyState();
        emptyStateInput();
    }

    const emptyState = () => {
        setError({});
    }
    const emptyStateInput = () => {
        setForm({});
    };

    const handleAdd = () => {
        setView(false);
        handleOpen();
    }

    const onExport = () => {
        loadImportExportData('Workflow');
    }

    const onEdit = (data) => {
        setView(false);
        handleOpen();
        setForm(data);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setWorkflowId(data.id);
        setName(data.name);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.WORKFLOW_START,
            url: 'v1/schedules/workflow',
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const handleClose = () => {
        setVisible(false);
        emptyState();
        emptyStateInput();
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(createDetails);
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            setError({
                ...error,
                "name": text
            })
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Schedule Workflow', history, 'Younote Admin')) {
                loadTasks();
            }
        }
    }, [roleManagement]);

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value
            });
        }
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(editDetails);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            setError({
                ...error,
                "name": text
            })
        }
    }, [editDetails, editError]);


    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
    });

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ action: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ actionStatus: { like: '%' + search.trim() + '%' } });
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'v1/schedules/workflow',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search)
            || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const handleImportClose = () => {
        setImportVisible(false);
    }

    const createWorkflow = (e) => {
        e.preventDefault();
        let emptyName = emptyValidation('Name', form.name);
        let emptyAction = emptyValidation('Name', form.action, 'dropDown');
        let emptyStatus = emptyValidation('Action Status', form.actionStatus, 'dropDown');

        emptyState();
        if (emptyName.isValid && emptyAction.isValid && emptyStatus.isValid) {
            dispatch({
                type: form?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: "v1/schedules/workflow",
                title: "Workflow",
                id: form?.id,
                details: {
                    ...form,
                    name: form?.name.trim(),
                    description: form?.description.trim()
                }
            })
        } else {
            setError({
                'name': emptyName.errors,
                'action': emptyAction.errors,
                'actionStatus': emptyStatus.errors,
            });
        }
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const onView = (data) => {
        setView(true);
        handleOpen();
        setForm(data);
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={'Younote Admin'} links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Schedule Workflow', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Schedule Workflow'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Schedule Workflow', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Schedule Workflow', 'create', 'Younote Admin') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleAdd()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Workflow</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Schedule Workflow', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => onExport()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                onEdit={(data) => onEdit(data)}
                                onDelete={(data) => onDelete(data)}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreTask={() => loadMoreTask()}
                                loadMoreContent={loadMoreContent}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                onView={(data) => onView(data)}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                            />
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={`${form?.id ? `${view ? 'View' : 'Edit'}` : 'Add'} Workflow`}
                width={'360px'}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => createWorkflow(e)}>
                        <div className={classes.customFormFlex}>
                            <Row type="flex" gutter={40}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Name</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.brandName}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label={["Name ", <span key={"Name"} className={classes.colorRedRequired}> *</span>]}
                                                variant={'standard'}
                                                error={error.name ? true : false}
                                                helperText={error.name}
                                                name={"name"}
                                                fullWidth
                                                value={form?.name}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Description</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.description}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label='Description'
                                                name={"description"}
                                                value={form?.description}
                                                multiline
                                                variant="outlined"
                                                fullWidth
                                                className={clsx(classes.margin20t, classes.customDescription)}
                                                rows={3}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColor,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Action</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.action}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Action ", <span key={'Action'} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'label', 'name': 'Name' }]}
                                                details={[{ "id": "BILL", "label": "Bill" }, { "id": "ORDER", "label": "Order" }]}
                                                parentValue={customObject([{ "id": "BILL", "label": "Bill" }, { "id": "ORDER", "label": "Order" }], form?.action)}
                                                onChange={(data) => changeHandler(data.id, 'action')}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={error.action}
                                            />
                                    }
                                </Col>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Action</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.actionStatus}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Action Status ", <span key={'Action Status'} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'label', 'name': 'Name' }]}
                                                details={[{ "id": "CREATE", "label": "Create" }, { "id": "CONFIRM", "label": "Confirm" }]}
                                                parentValue={customObject([{ "id": "CREATE", "label": "Create" }, { "id": "CONFIRM", "label": "Confirm" }], form?.actionStatus)}
                                                onChange={(data) => changeHandler(data.id, 'actionStatus')}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={error.actionStatus}
                                            />
                                    }
                                </Col>
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            {
                                !view ?
                                    <Space direction="horizontal" align="center" size={[10, 10]}>
                                        <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            type={'submit'}
                                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                            {
                                                form?.id ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                        {
                                            !form?.id &&
                                            <Button
                                                key="save"
                                                color="primary"
                                                variant="contained"
                                                onClick={(e) => handleAddMore(e)}
                                                className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                            >Add More</Button>
                                        }
                                    </Space> : <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => setView(false)}>Edit</NavLink>
                            }
                        </div>
                    </Box>
                }
            />
            <ImportExport
                handleClose={() => handleImportClose()}
                visible={importVisible}
                title={'Workflow'}
                type={"import"}
                details={workflowDetails}
                loader={workflowLoader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder); }}
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={workflowId} loadTasks={() => dispatchFilter(sortBy, sortOrder)} name={name} url={'v1/schedules/workflow'}
                title={'Workflow'} visible={deleteModal} />
        </React.Fragment>
    );
}

export default WorkFlow